import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';

const Navigation = () => {
  const { t, language, changeLanguage, isRTL } = useTranslation();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-white shadow-lg border-b border-gray-200">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          {/* Logo and Title */}
          <div className="flex items-center space-x-4 rtl:space-x-reverse">
            <div className="text-2xl font-bold text-blue-600">
              💰
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-800">{t('app.title')}</h1>
              <p className="text-sm text-gray-600">{t('app.subtitle')}</p>
            </div>
          </div>

          {/* Navigation Links */}
          <div className="flex items-center space-x-6 rtl:space-x-reverse">
            <Link
              to="/"
              className={`nav-link ${isActive('/') ? 'active' : ''}`}
            >
              📊 {t('nav.dashboard')}
            </Link>
            <Link
              to="/add"
              className={`nav-link ${isActive('/add') ? 'active' : ''}`}
            >
              ➕ {t('nav.add_transaction')}
            </Link>
            <Link
              to="/transactions"
              className={`nav-link ${isActive('/transactions') ? 'active' : ''}`}
            >
              📋 {t('nav.transactions')}
            </Link>

            {/* Language Toggle */}
            <button
              onClick={() => changeLanguage(language === 'ar' ? 'en' : 'ar')}
              className="btn-secondary flex items-center space-x-2 rtl:space-x-reverse"
            >
              <span className="text-lg">🌐</span>
              <span>{language === 'ar' ? 'EN' : 'عربي'}</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;